import React, { useEffect, useState } from "react";
import "../ResellerDashboard/style.scss";
import { Button, Modal } from "react-bootstrap";
import { postData } from "../../api";
import Loader from "../../components/Loader";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import TitleCard from "./titleCard";
import DashboardCard from "./dashboardCard";
import ResellerTable from "./resellerTable";

const ResellerDashboard = () => {
  const getResellerDetails = localStorage.getItem("guhroo_user_details");
  const [listData, setListData] = useState([]);
  const currentDate = new Date();
  const [clientStats, setClientStats] = useState({
    activeClient: 0,
    inactiveClient: 0,
  });
  const [userStats, setUserStats] = useState({
    activeUsers: 0,
    inactiveUsers: 0,
  });
  const [userId, setUserId] = useState("");
  const [sortDirection, setSortDirection] = useState("date");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedFrequency, setSelectedFrequency] = useState("");
  const [loading, setLoading] = useState(false);
  const [BtnLoading, setBtnLoading] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState({
    frequency: "",
    dateRange: [null, null],
  });
  const [frequencyOptions, setFrequencyOptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [dateRange, setDateRange] = useState([null, null]);
  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
  );
  const [isReseller, setIsReseller] = useState(false);

  useEffect(() => {
    const resellerDetails = JSON.parse(getResellerDetails);
    setIsReseller(resellerDetails?.isReseller ?? false);
  }, [getResellerDetails]);

  // Add this function to get the ordinal suffix
  const getOrdinalSuffix = (day) => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const month = currentDate.toLocaleString("default", { month: "long" });
  const day = currentDate.getDate();
  const dayWithSuffix = `${day}${getOrdinalSuffix(day)}`; // Format day with suffix
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const dayOfWeek = days[currentDate.getDay()];
  const handleActionClick = (client) => {
    setSelectedClient(client);
    setShowModal(true);
  };

  // Handler for modal actions
  const handleModalClose = () => {
    setShowModal(false);
    setSelectedClient(null);
  };

  const handleModalConfirm = async () => {
    setBtnLoading(true);
    try {
      let data = {
        client_id: selectedClient?.client_id,
        legal_name: selectedClient?.legal_name,
        pay_frequency: selectedClient?.pay_frequency,
        start_date: selectedClient?.start_date,
        end_date: selectedClient?.end_date,
        pay_schedule_uuid: selectedClient?.pay_schedule_uuid,
        process_date: selectedClient?.process_date,
        process_status: selectedClient?.process_status,
        upcoming_pay_date: selectedClient?.upcoming_pay_date,
        reseller_name: selectedClient?.reseller_name,
      };

      const response = await postData("paydate-remainder", {}, data);

      if (response?.status === true) {
        toast.success(response.message, {
          theme: "colored",
          autoClose: 3000,
          style: {
            borderRadius: "16px",
          },
        });
      } else {
        toast.error(response.message, {
          theme: "colored",
          autoClose: 3000,
          style: {
            borderRadius: "16px",
          },
        });
      }
    } catch (e) {
      toast.error("Something went wrong");
      console.log(e);
    } finally {
      setBtnLoading(false);
      handleModalClose();
    }
  };

  //get user_id
  const handleGetUserInfo = async () => {
    setLoading(true);
    const res = await postData("get_user_details", {}, {});
    try {
      if (res?.status === true) {
        setUserId(res?.data?.user_id);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const getData = async () => {
    setLoading(true);
    const payLoad = {
      user_id: userId,
    };
    try {
      const response = await postData("reseller-dashbaord", {}, payLoad);
      if (response?.status === true) {
        setClientStats({
          activeClient: response?.data?.client?.active,
          inactiveClient: response?.data?.client?.in_active,
        });
        setUserStats({
          activeUsers: response?.data?.user?.active,
          inactiveUsers: response?.data?.user?.in_active,
        });
        setListData(response?.data?.list || []);
        setLoading(false);
        setFrequencyOptions(
          response?.data?.frequency_list.map((frequency, index) => ({
            id: index + 1,
            label: frequency,
          }))
        );
      }
    } catch (e) {
      console.log(e);
      setListData([]);
    } finally {
      setLoading(false);
    }
  };

  // Update the applyFilters function
  const applyFilters = (data) => {
    let filteredData = [...data];

    // Apply search filter (always active)
    if (searchTerm) {
      filteredData = filteredData.filter((item) =>
        item?.legal_name?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Apply frequency filter (only when FILTER button is clicked)
    if (appliedFilters.frequency) {
      filteredData = filteredData.filter(
        (item) =>
          item?.pay_frequency?.toLowerCase() ===
          appliedFilters.frequency.toLowerCase()
      );
    }

    // Apply date range filter (only when FILTER button is clicked)
    if (
      appliedFilters.dateRange &&
      appliedFilters.dateRange[0] &&
      appliedFilters.dateRange[1]
    ) {
      filteredData = filteredData.filter((item) => {
        const payDate = new Date(item.upcoming_pay_date);
        // Set end date to end of day (23:59:59) to include the entire end date
        const endDate = new Date(appliedFilters.dateRange[1]);
        endDate.setHours(23, 59, 59, 999);
        return payDate >= appliedFilters.dateRange[0] && payDate <= endDate;
      });
    }

    return filteredData;
  };

  // Update handleFilterClick
  const handleFilterClick = () => {
    if (selectedFrequency || (dateRange[0] && dateRange[1])) {
      setAppliedFilters({
        frequency: selectedFrequency,
        dateRange: dateRange,
      });
      setCurrentPage(1);
    } else {
      // If no filters are selected, show a message
      // toast.info("Please select at least one filter (Pay Frequency or Date Range)");
    }
  };

  // Add a function to clear all filters
  const clearFilters = () => {
    setSelectedFrequency("");
    setDateRange([null, null]);
    setAppliedFilters({
      frequency: "",
      dateRange: [null, null],
    });
    setCurrentPage(1);
  };

  const sortData = (data, key, direction) => {
    if (!direction) return data;

    return [...data].sort((a, b) => {
      // Handle null/undefined values by placing them at the end
      if (a[key] === null || a[key] === undefined) return 1;
      if (b[key] === null || b[key] === undefined) return -1;

      const valueA = a[key].toString().toLowerCase();
      const valueB = b[key].toString().toLowerCase();

      return valueA.localeCompare(valueB);
    });
  };

  // Update your getSortedData function to use the utility
  const getSortedData = (data) => {
    if (sortDirection === "asc") {
      return sortData(data, "legal_name", "asc");
    } else {
      return [...data].sort(
        (a, b) => new Date(b.creation_date) - new Date(a.creation_date)
      );
    }
  };

  const filteredPaymentData = getSortedData(applyFilters(listData));

  // Pagination calculations
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredPaymentData.slice(
    indexOfFirstRow,
    indexOfLastRow
  );
  const totalPages = Math.ceil(filteredPaymentData.length / rowsPerPage);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(
        new Date().toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        })
      );
    }, 1000);

    // Cleanup interval on component unmount
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    // First get user info
    const fetchUser = async () => {
      await handleGetUserInfo();
    };
    fetchUser();
  }, []);

  useEffect(() => {
    if (userId) {
      getData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, rowsPerPage]);
  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setCurrentPage(1);
  };

  return (
    <>
      {loading ? (
        <div className="loader-container">
          <Loader />
        </div>
      ) : (
        <div className="reseller-dashboard">
          <>
            <TitleCard
              month={month}
              dayWithSuffix={dayWithSuffix}
              dayOfWeek={dayOfWeek}
              currentTime={currentTime}
              isReseller={isReseller}
            />
          </>
          <>
            <DashboardCard clientStats={clientStats} userStats={userStats} />
          </>
          <>
            <ResellerTable
              listData={listData}
              dateRange={dateRange}
              setDateRange={setDateRange}
              selectedFrequency={selectedFrequency}
              frequencyOptions={frequencyOptions}
              setSelectedFrequency={setSelectedFrequency}
              handleFilterClick={handleFilterClick}
              clearFilters={clearFilters}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              currentRows={currentRows}
              setSortDirection={setSortDirection}
              sortDirection={sortDirection}
              handleActionClick={handleActionClick}
              filteredPaymentData={filteredPaymentData}
              rowsPerPage={rowsPerPage}
              currentPage={currentPage}
              totalPages={totalPages}
              handleRowsPerPageChange={handleRowsPerPageChange}
              setCurrentPage={setCurrentPage}
            />
          </>
        </div>
      )}
      <Modal show={showModal} onHide={handleModalClose} centered>
        <Modal.Body>
          <div className="remind-modal-content">
            <p className="remind-modal-message">
              Are you sure you want to remind the client admin?
            </p>
            <div className="remind-modal-actions">
              <Button
                className="model-btn"
                onClick={BtnLoading ? null : handleModalConfirm}
                disabled={loading}
              >
                {BtnLoading ? <Spinner animation="border" size="sm" /> : "Yes"}
              </Button>
              <Button
                className="model-btn_secondary"
                onClick={handleModalClose}
                disabled={loading}
              >
                Cancel
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ResellerDashboard;
